import React from 'react'
import Svg from 'src/Components/shared/Svg'

const PuzzleHexagon = props => (
  <Svg viewBox='0 0 50 54' width={50} height={54} fill='none' {...props}>
    <g filter='url(#prefix__filter0_d)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M48 36.458l-.248-20.384c-.02-1.65-.942-3.183-2.419-4.025L27.075 1.646c-1.477-.841-3.283-.862-4.741-.055L4.322 11.57A4.466 4.466 0 002 15.542l.247 20.385c.021 1.65.942 3.183 2.419 4.024l18.258 10.404c1.477.841 3.283.862 4.741.055l18.013-9.982A4.466 4.466 0 0048 36.457z'
        fill='#535256'
      />
    </g>
    <path
      d='M34.75 23.5H32.5V19a1.5 1.5 0 00-1.5-1.5h-4.5v-2.25a2.25 2.25 0 00-4.5 0v2.25h-4.5A1.5 1.5 0 0016 19v4.5h2.25a2.25 2.25 0 010 4.5H16v4.5a1.5 1.5 0 001.5 1.5H22v-2.25a2.25 2.25 0 014.5 0V34H31a1.5 1.5 0 001.5-1.5V28h2.25a2.25 2.25 0 000-4.5z'
      fill='#BBB2B7'
    />
    <defs>
      <filter
        id='prefix__filter0_d'
        x={0}
        y={0}
        width={50}
        height={54}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
      </filter>
    </defs>
  </Svg>
)

export default PuzzleHexagon
